import { ChevronDown } from "lucide-react";
import type { ShiftProductionFormListItem } from "../../../shared/shift-production-form/contracts";
import { GroupedApprovalPreviews } from "./GroupedApprovalPreviews";

type Props = {
  items: ShiftProductionFormListItem[];
  total: number | null;
  phase: "loading" | "ready" | "error";
  error: string | null;
  busy: boolean;
  onOpen: (id: string) => void;
  onReload: () => void;
};

export function TodayApprovedForms({ items, total, phase, error, busy, onOpen, onReload }: Props) {
  return (
    <details className="approval-today" onToggle={event => { if (event.currentTarget.open) onReload(); }}>
      <summary>
        <span>Bugün onayladıklarım{phase === "ready" && total !== null ? <span className="approval-today-count"> · {total}</span> : null}</span>
        <ChevronDown size={16} aria-hidden="true" />
      </summary>
      <div className="approval-today-content" aria-busy={phase === "loading"}>
        {phase === "loading" ? <p role="status">Bugünkü onaylar yükleniyor…</p> : null}
        {phase === "error" ? <div role="alert"><p>{error}</p><button type="button" onClick={onReload}>Tekrar dene</button></div> : null}
        {phase === "ready" && !items.length ? <p>Bugün henüz onayladığınız form yok.</p> : null}
        {phase === "ready" && items.length ? <GroupedApprovalPreviews items={items} busy={busy} approved label="Bugün onayladığınız form önizlemeleri" onOpen={onOpen} /> : null}
      </div>
    </details>
  );
}
